


















import Vue from 'vue';
import Sidebar from '@/components/Navigation/Sidebar.vue';

import LogoutForm from '@/components/Form/LogoutForm.vue';
// import CopyrightPanel from '@/components/Common/CopyrightPanel.vue';

export default Vue.extend({
    name: 'BaseLayout',
    components: {
        Sidebar,
        LogoutForm,
        // CopyrightPanel,
    },
    data() {
        return {
            sidebarOffsetWidth: '350px',
        }
    }
});
